import UIDropdown from 'shared-web/src/components/UIDropdown'
import UIDropdownItem from 'shared-web/src/components/UIDropdownItem'

import { Icon } from '@driftt/tide-core-legacy'
import TRASH_ICON from 'images/svg/trash-red.svg'

import styles from './style.styl'

const OptionsDropdown = ({ handleEditClick, handleDeleteClick }) => (
  <div className={styles.OptionsDropdown}>
    <UIDropdown
      title={
        <button className="options-dropdown-button tide-button tide-button--tertiary small">
          <Icon className="options-dropdown-icon" name="chevron-down" width="20" />
        </button>
      }
      attachment="top right"
      targetAttachment="bottom right"
      offset="8px 0px"
    >
      {!!handleEditClick && (
        <UIDropdownItem onClick={handleEditClick}>
          <div className="flex">
            <Icon className="item-icon" name="edit-1" width="15" />
            Edit
          </div>
        </UIDropdownItem>
      )}

      {!!handleDeleteClick && (
        <UIDropdownItem onClick={handleDeleteClick}>
          <div className="flex trash-icon">
            <img className="item-icon" src={TRASH_ICON} width="15" />
            Delete
          </div>
        </UIDropdownItem>
      )}
    </UIDropdown>
  </div>
)

export default OptionsDropdown



// WEBPACK FOOTER //
// ./src/scripts/components/shared/OptionsDropdown/component.js